import tlFallback from "@/assets/images/TL.png"

export const DEFAULT_ORGANIZATION_NAME = "Teaming App"

export type OrganizationBrand = {
	name?: string | null
	logo?: string | null
	default_image?: string | null
} | null | undefined

/**
 * Brand / placeholder image: organization logo first, then TL asset.
 */
export function resolveOrganizationLogo(
	organization: OrganizationBrand,
	fallback: string = tlFallback
): string {
	const logo = organization?.logo
	if (typeof logo === "string" && logo.trim()) {
		return logo.trim()
	}
	return fallback
}

/** Organization display name, or "Teaming App" when missing. */
export function resolveOrganizationName(
	organization: OrganizationBrand,
	fallback: string = DEFAULT_ORGANIZATION_NAME
): string {
	const name = organization?.name
	if (typeof name === "string" && name.trim()) {
		return name.trim()
	}
	return fallback
}

export { tlFallback }
